// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l9FE","right":"styles_right__jZf_D"};